import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import {
  ContextMenu,
  CONTEXT_MENU_VARIANT_DARK
} from '../ContextMenu/ContextMenu'
import {
  ButtonAction,
  ACTION_BUTTON_TYPE_ACTIONS
} from '../ButtonAction/ButtonAction'
import { makeButtonWithMenu } from '../ButtonWithMenu'

import './Actions.scss'

export const MENU_POSITION_LEFT = 'MENU_POSITION_LEFT'
export const MENU_POSITION_RIGHT = 'MENU_POSITION_RIGHT'

export const Actions = ({
  items,
  menuPosition,
  className,
  disabled,
  'data-mu-test': dataAttributeTest
}) => {
  const ButtonComponent = () =>
    items.length > 0 && (
      <ButtonAction disabled={disabled} type={ACTION_BUTTON_TYPE_ACTIONS} />
    )

  const MenuComponent = () => (
    <ContextMenu
      className='c-actions__menu'
      variant={CONTEXT_MENU_VARIANT_DARK}
      items={items}
    />
  )

  const ActionButtonWithMenu = makeButtonWithMenu(
    ButtonComponent,
    MenuComponent
  )

  return (
    <ActionButtonWithMenu
      className={classnames('c-actions', className, {
        'c-actions--left': menuPosition === MENU_POSITION_LEFT,
        'c-actions--right': menuPosition === MENU_POSITION_RIGHT
      })}
      data-mu-test={classnames('actions', dataAttributeTest)}
    />
  )
}

Actions.defaultProps = {
  menuPosition: MENU_POSITION_LEFT
}

Actions.propTypes = {
  menuPosition: PropTypes.oneOf([MENU_POSITION_LEFT, MENU_POSITION_RIGHT]),
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      separator: PropTypes.bool,
      className: PropTypes.string,
      onClick: PropTypes.func,
      value: PropTypes.any,
      hide: PropTypes.bool
    })
  ),
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
